import {
  IsNotEmpty,
  IsString,
  IsUUID,
  IsNumber,
  IsOptional,
  IsBoolean,
} from 'class-validator';

export class GetUnitTreeOptionsDto {
  @IsNotEmpty()
  @IsString()
  query: string;

  @IsNotEmpty()
  @IsNumber()
  limit: number;

  @IsNotEmpty()
  @IsNumber()
  offset: number;

  @IsUUID()
  company_id?: string;

  @IsOptional()
  @IsString()
  unit_type?: string;

  @IsBoolean()
  @IsOptional()
  query_include_root?: boolean;
}
